import type { NoteState } from "../model/NoteState";
import { buildGuessDisplay } from "../model/NoteState";
import type { DebugSnapshot } from "../types/debug";

export interface HudLines {
  readonly truthLine: string;
  readonly guessLine: string;
}

export function buildTruthLine(snapshot: DebugSnapshot): string {
  return snapshot.state.symbolSequence.expanded.join(" ");
}

export function buildHudLines(snapshot: DebugSnapshot, noteState: NoteState): HudLines {
  return {
    truthLine: buildTruthLine(snapshot),
    guessLine: buildGuessDisplay(noteState, snapshot.state.symbolSequence.raw),
  };
}

export interface DomFactory {
  createElement(tagName: string): HTMLElement;
}

function defaultDomFactory(): DomFactory {
  return {
    createElement: (tag: string) => document.createElement(tag),
  };
}

export class HudRenderer {
  private truthEl: HTMLElement | null = null;
  private guessEl: HTMLElement | null = null;

  public render(
    container: HTMLElement,
    snapshot: DebugSnapshot,
    noteState: NoteState,
    factory: DomFactory = defaultDomFactory(),
  ): void {
    const lines = buildHudLines(snapshot, noteState);

    if (this.truthEl === null) {
      this.truthEl = factory.createElement("div");
      this.truthEl.dataset["testid"] = "hud-true-line";
      container.appendChild(this.truthEl);
    }
    this.truthEl.textContent = lines.truthLine;

    if (this.guessEl === null) {
      this.guessEl = factory.createElement("div");
      this.guessEl.dataset["testid"] = "hud-guess-line";
      container.appendChild(this.guessEl);
    }
    this.guessEl.textContent = lines.guessLine;
  }
}
